export function asyncSelectWidgetObjectName(code: string) {
  return `${code}@object`;
}
